import classNames from 'classnames';
import type { IntlKey } from 'locales';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  children?: ReactNode;
  className?: string;
  iconName?: string;
  textIntlKey?: IntlKey;
  color?: 'info' | 'info-alpha' | 'error';
}

export function SubmissionStatus({ className, iconName, textIntlKey, color = 'info-alpha', children }: Props) {
  return (
    <div
      data-e2e="missedDealFeedback-status"
      className={classNames('d-flex align-items-center fw-bold w-100 p-3', className, {
        'alert alert-discreet-info': color === 'info-alpha',
        'bg-info text-white': color === 'info',
        'alert alert-discreet-danger': color === 'error',
      })}
    >
      {iconName && <i className="icon icon-md pe-3">{iconName}</i>}
      {textIntlKey && (
        <span
          className={classNames('flex-grow-1', {
            'ps-4 ms-3': !iconName,
          })}
        >
          <FormattedMessage
            id={textIntlKey}
            values={{ mail: m => <a href="mailto:list.eur-mark-eng-dat@sgcib.com">{m}</a> }}
          />
        </span>
      )}
      {children}
    </div>
  );
}
